import { render, staticRenderFns } from "./MonitorProcesso.vue?vue&type=template&id=dbdc5c40"
import script from "./MonitorProcesso.vue?vue&type=script&lang=js"
export * from "./MonitorProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports